var QRCode = require("qrcode");

export default (context, inject) => {
  inject("QRCode", QRCode);
};
